import CallIcon from '@mui/icons-material/Call';
import React, { useState } from 'react';

import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';


import bot from '../../assets/images/happy.png'
import Lastmenu from './Lastmenu';


const ContactUs = () =>{

    
        const [time] = useState(new Date());
    return (
        <>
        <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
        <div className='frame1 animated-frame'>
            <h2 style={{ textAlign: "center", color: "#fe5631", marginTop: "-5px"}}>Contact Us</h2>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px',marginTop:'10px' }}>

            <div style={{ display: 'flex', alignItems: 'center' }}>
                        <CallIcon style={{ color: '#ef5124', marginRight: '10px' }} /><strong>Phone:&nbsp; </strong>
                        <a href="tel:+918880747474" target="_blank" rel="noopener noreferrer " style={{ textDecoration: 'none' }}>
                        +91 8880747474
                        </a>    
                    </div>

                                    {/* Facebook */}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <FacebookIcon style={{ color: '#3b5998', marginRight: '10px' }} /><strong>Facebook:&nbsp; </strong>
                        <a href="https://www.facebook.com/hegdefertility" target="_blank" rel="noopener noreferrer " style={{ textDecoration: 'none' }}>
                        www.facebook.com
                        </a>
                    </div>

                                    {/* Twitter */}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <TwitterIcon style={{ color: '#1DA1F2', marginRight: '10px' }} />
                        <strong>Twitter:&nbsp;</strong>
                        <a href="https://x.com/Hegde_Fertility" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                        www.x.com
                        </a>
                    </div>

                    {/* Instagram */}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <InstagramIcon style={{ color: '#E1306C', marginRight: '10px' }} />
                        <strong>Instagram:&nbsp;</strong>
                        <a href="https://www.instagram.com/hegde.fertility/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                        www.instagram.com
                        </a>
                    </div>

                    {/* LinkedIn */}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <LinkedInIcon style={{ color: '#0077b5', marginRight: '10px' }} />
                        <strong>LinkedIn:&nbsp;</strong>
                        <a href="https://www.linkedin.com/company/hegdefertility/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                        www.linkedin.com
                        </a>
                    </div>

                    {/* YouTube */}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <YouTubeIcon style={{ color: '#FF0000', marginRight: '10px' }} />
                        <strong>YouTube:&nbsp;</strong>
                        <a href="https://www.youtube.com/@Hegdefertility" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                        www.youtube.com
                        </a>
                    </div>

                    {/* WhatsApp */}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <WhatsAppIcon style={{ color: '#25D366', marginRight: '10px' }} />
                        <strong>WhatsApp:&nbsp;</strong>
                        <a href="https://wa.me/919963411266" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                        +91 9963411266
                        </a>
                        </div>
            </div>


       </div>
       <Lastmenu />
       </>
    );
}
export default ContactUs;